import { render } from "./close.svg?vue&type=template&id=784ac6f6"
const script = {}
script.render = render

export default script